"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebArea = exports.MBUSDPlatform = exports.Operation = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "Operation", { enumerable: true, get: function () { return web_ui_framework_1.Operation; } });
Object.defineProperty(exports, "MBUSDPlatform", { enumerable: true, get: function () { return web_ui_framework_1.MBUSDPlatform; } });
Object.defineProperty(exports, "WebArea", { enumerable: true, get: function () { return web_ui_framework_1.WebArea; } });
//# sourceMappingURL=types.js.map